import { Routes } from "../../methods/ApiRoutes";

const shared = {
  title: 'Transactions',
  addTitle: 'Transaction',
  url: 'transaction',
  ...Routes.Transactions,
};

export default shared;
